module.exports = __webpack_public_path__ + "img/nav_mobil_menu.918f70d9.svg";